 import { authenticatedFetch } from "../Auth/Auth";
 import { getCurrentConfig } from '../../config/config';
 
 const config = getCurrentConfig();


export const mapboxaddressSearch = async (queryString) => {



  const response = await authenticatedFetch(`${config.API_BASE_URL}/mapboxaddressSearch`, {
      method: 'POST',
      headers: {
      
        'Content-Type': 'application/json',
      'User-Agent': 'agentApp/1.0',
      },
      body: JSON.stringify({urlQuery: queryString})
  });
  
    if (response.ok) {
      const responseData = await response.json();
      return responseData;
  } else {
      throw new Error(`Error fetching data from searching address`);
  }

}


export const qaddressSearch = async (urlqueryString) => {
   

     const response = await authenticatedFetch(`${config.API_BASE_URL}/addressSearch`, {
         method: 'POST',
         headers: {
         
           'Content-Type': 'application/json',
          'User-Agent': 'agentApp/1.0',
         },
         body: JSON.stringify({urlQueryString: urlqueryString})
      });
      
       if (response.ok) {
         const responseData = await response.json();
         return responseData;
      } else {
         throw new Error(`Error fetching data from quick address search`);
      }



      




};